import moment from 'moment';

export const computeDateRange = (date, viewMode, customStart, customEnd) => {
    let start, end;
    const m = moment(date);

    if (viewMode === 'week') {
        start = m.clone().startOf('week');
        end = m.clone().endOf('week');
    } else if (viewMode === 'month') {
        start = m.clone().startOf('month').startOf('week');
        end = m.clone().endOf('month').endOf('week');
    } else if (viewMode === '5week') {
        start = m.clone().startOf('week');
        end = start.clone().add(34, 'days');
    } else {
        start = moment(customStart);
        end = moment(customEnd);
    }

    const days = [];
    const cursor = start.clone();
    while (cursor.isSameOrBefore(end, 'day')) {
        days.push(cursor.format('YYYY-MM-DD'));
        cursor.add(1, 'day');
    }

    return { days, start, end };
};
